interface Props {
  hasUnsavedChanges: boolean;
}

export default function ButtonSave({ hasUnsavedChanges }: Props) {
  return (
    <button
      type="submit"
      className={
        hasUnsavedChanges
          ? "cabinet_profileeditmodal-right-button-unsaved"
          : "cabinet_profileeditmodal-right-button-saved"
      }
    >
      Сохранить
    </button>
  );
}
